// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"005f4a32","784":"f41937a2"}[chunkId] + ".chunk.js";
};